<template>
  <div class="account-page">
    <div class="panel-card">
      <!-- Toggle Buttons -->
      <div class="mb-4 d-flex gap-2 flex-wrap">
        <button
          class="btn"
          :class="showPasswordForm ? 'btn-outline-light' : 'btn-primary'"
          @click="showPasswordForm = false"
        >
          <i class="fas fa-user me-2"></i>Datos personales
        </button>
        <button
          class="btn"
          :class="showPasswordForm ? 'btn-primary' : 'btn-outline-light'"
          @click="showPasswordForm = true"
        >
          <i class="fas fa-key me-2"></i>Cambiar contraseña
        </button>
      </div>

      <!-- Personal Data Form -->
      <form v-if="!showPasswordForm" @submit.prevent="handleSubmit">
        <div class="row g-3">
          <div class="col-md-6">
            <div class="form-group">
              <label>Nombre</label>
              <input
                v-model="formData.first_name"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': v$.first_name.$error }"
                placeholder="Tu nombre"
              >
              <div class="invalid-feedback" v-if="v$.first_name.$error">
                {{ v$.first_name.$errors[0].$message }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Apellido</label>
              <input
                v-model="formData.last_name"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': v$.last_name.$error }"
                placeholder="Tu apellido"
              >
              <div class="invalid-feedback" v-if="v$.last_name.$error">
                {{ v$.last_name.$errors[0].$message }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>DNI</label>
              <input
                v-model="formData.dni"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': v$.dni.$error }"
                placeholder="DNI"
                inputmode="numeric"
                maxlength="20"
              >
              <div class="invalid-feedback" v-if="v$.dni.$error">
                {{ v$.dni.$errors[0].$message }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Teléfono</label>
              <input
                v-model="formData.phone_number"
                type="tel"
                class="form-control"
                :class="{ 'is-invalid': v$.phone_number.$error }"
                placeholder="Teléfono"
                inputmode="numeric"
                autocomplete="tel"
              >
              <div class="invalid-feedback" v-if="v$.phone_number.$error">
                {{ v$.phone_number.$errors[0].$message }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>CUIT/CUIL</label>
              <input
                v-model="formData.cuit"
                type="text"
                class="form-control"
                placeholder="CUIT/CUIL (opcional)"
                maxlength="20"
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Instagram</label>
              <input
                v-model="formData.instagram"
                type="text"
                class="form-control"
                placeholder="Instagram (opcional)"
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Facebook</label>
              <input
                v-model="formData.facebook"
                type="text"
                class="form-control"
                placeholder="Facebook (opcional)"
              >
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Email</label>
              <input
                v-model="formData.email"
                type="email"
                class="form-control"
                :class="{ 'is-invalid': v$.email.$error }"
                placeholder="tu@email.com"
              >
              <div class="invalid-feedback" v-if="v$.email.$error">
                {{ v$.email.$errors[0].$message }}
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="form-group">
              <label>Dirección</label>
              <input
                v-model="formData.address"
                type="text"
                class="form-control"
                placeholder="Dirección (opcional)"
              >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Código postal</label>
              <input
                v-model="formData.postal_code"
                type="text"
                class="form-control"
                placeholder="CP (opcional)"
                maxlength="10"
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Provincia</label>
              <input
                v-model="formData.province"
                type="text"
                class="form-control"
                placeholder="Provincia (opcional)"
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Localidad</label>
              <input
                v-model="formData.locality"
                type="text"
                class="form-control"
                placeholder="Localidad (opcional)"
              >
            </div>
          </div>
        </div>

        <!-- Datos del negocio (según rol) -->
        <div v-if="showBusinessSection" class="business-section">
          <div class="business-section-title">
            <i class="fas fa-store me-2"></i>Datos del negocio
          </div>
          <div class="row g-3">
            <div class="col-12">
              <div class="form-group">
                <label>Nombre del negocio</label>
                <input
                  v-model="formData.business_name"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.business_name?.$error }"
                  placeholder="Nombre del local/organización"
                >
                <div class="invalid-feedback" v-if="v$.business_name?.$error">
                  {{ v$.business_name.$errors[0].$message }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label>Dirección del negocio</label>
                <input
                  v-model="formData.business_address"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.business_address?.$error }"
                  placeholder="Dirección del negocio"
                >
                <div class="invalid-feedback" v-if="v$.business_address?.$error">
                  {{ v$.business_address.$errors[0].$message }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label>Tipo de negocio</label>
                <input
                  v-model="formData.business_type"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.business_type?.$error }"
                  placeholder="Ej: growshop, dispensario"
                >
                <div class="invalid-feedback" v-if="v$.business_type?.$error">
                  {{ v$.business_type.$errors[0].$message }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label>Comentarios adicionales</label>
                <textarea
                  v-model="formData.extra_info"
                  class="form-control"
                  rows="3"
                  placeholder="Comentarios adicionales (opcional)"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn btn-primary" :disabled="isLoading">
            <i class="fas fa-save me-2"></i>{{ isLoading ? 'Guardando...' : 'Guardar cambios' }}
          </button>
        </div>
      </form>

      <!-- Password Change Form -->
      <form v-else @submit.prevent="handlePasswordChange">
        <div class="row g-3">
          <div class="col-12">
            <div class="form-group">
              <label>Contraseña actual</label>
              <div class="input-group">
                <input
                  :type="showCurrentPassword ? 'text' : 'password'"
                  v-model="passwordForm.currentPassword"
                  class="form-control"
                  placeholder="Ingresa tu contraseña actual"
                >
                <button type="button" class="btn btn-outline-secondary" @click="showCurrentPassword = !showCurrentPassword">
                  <i :class="showCurrentPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Nueva contraseña</label>
              <div class="input-group">
                <input
                  :type="showNewPassword ? 'text' : 'password'"
                  v-model="passwordForm.newPassword"
                  class="form-control"
                  placeholder="Nueva contraseña"
                >
                <button type="button" class="btn btn-outline-secondary" @click="showNewPassword = !showNewPassword">
                  <i :class="showNewPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Confirmar nueva contraseña</label>
              <div class="input-group">
                <input
                  :type="showConfirmPassword ? 'text' : 'password'"
                  v-model="passwordForm.confirmPassword"
                  class="form-control"
                  placeholder="Confirma tu nueva contraseña"
                >
                <button type="button" class="btn btn-outline-secondary" @click="showConfirmPassword = !showConfirmPassword">
                  <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn btn-primary" :disabled="isChangingPassword">
            <i class="fas fa-key me-2"></i>{{ isChangingPassword ? 'Cambiando...' : 'Cambiar contraseña' }}
          </button>
        </div>
      </form>
    </div>

    <!-- Verification Modal -->
    <div v-if="showVerificationForm" class="verification-overlay">
      <div class="verification-modal">
        <h3>Verificar cambio de email</h3>
        <p>Te hemos enviado un código de verificación a tu nuevo email.</p>
        <div class="form-group">
          <label>Código de verificación</label>
          <input v-model="verificationCode" type="text" class="form-control" placeholder="Ingresa el código" maxlength="6">
        </div>
        <div class="modal-actions">
          <button class="btn btn-secondary" @click="showVerificationForm = false">Cancelar</button>
          <button class="btn btn-primary" @click="submitEmailChange" :disabled="!verificationCode">Verificar y cambiar</button>
        </div>
      </div>
    </div>

    <!-- Password Prompt Modal -->
    <div v-if="showPasswordModal" class="verification-overlay">
      <div class="verification-modal">
        <h3>Verificar identidad</h3>
        <p>Por favor, ingresa tu contraseña actual para continuar:</p>
        <div class="form-group">
          <label>Contraseña actual</label>
          <input v-model="currentPassword" type="password" class="form-control" placeholder="Ingresa tu contraseña">
        </div>
        <div class="modal-actions">
          <button class="btn btn-secondary" @click="handlePasswordCancel">Cancelar</button>
          <button class="btn btn-primary" @click="() => handlePasswordSubmit(currentPassword)" :disabled="!currentPassword">Confirmar</button>
        </div>
      </div>
    </div>

    <LoaderOverlay v-if="isRequestingCode" message="Enviando código de verificación..." />
    <LoaderOverlay v-if="isChangingPassword" message="Actualizando contraseña..." />
  </div>
</template>

<script setup>
import LoaderOverlay from '@/components/LoaderOverlay.vue'
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import { getUserInfo, updateUserProfile, changePassword, requestVerificationCode, updateEmailWithVerification } from '@/services/auth'
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, helpers } from '@vuelidate/validators'
import { useStore } from 'vuex'
import { extractApiErrorMessage } from '@/utils/apiErrors'
import { useUnsavedChangesGuard, useFormDirty } from '@/composables/useUnsavedChangesGuard'

const router = useRouter()
const toast = useToast()
const store = useStore()

const isLoading = ref(false)

const formData = reactive({
  first_name: '',
  last_name: '',
  dni: '',
  phone_number: '',
  cuit: '',
  instagram: '',
  facebook: '',
  email: '',
  address: '',
  postal_code: '',
  province: '',
  locality: '',
  business_name: '',
  business_address: '',
  business_type: '',
  extra_info: '',
})

const userRequiresBusinessInfo = ref(false)

const hasBusinessData = computed(() => {
  return !!(formData.business_name || formData.business_address || formData.business_type || formData.extra_info)
})

// Muestra la sección de negocio si el rol lo exige o ya hay datos cargados
const showBusinessSection = computed(() => {
  return userRequiresBusinessInfo.value || hasBusinessData.value
})

const phonePattern = helpers.withMessage(
  'Ingresá un teléfono válido (solo números, mínimo 10 dígitos)',
  helpers.regex(/^[0-9]{10,15}$/)
)

const dniPattern = helpers.withMessage(
  'Ingresá un DNI válido (solo números, 7 a 8 dígitos)',
  helpers.regex(/^[0-9]{7,8}$/)
)

const requiredTrimmed = (message) =>
  helpers.withMessage(message, (value) => String(value ?? '').trim().length > 0)

const rules = computed(() => {
  const base = {
    first_name: {
      required: helpers.withMessage('El nombre es requerido', required),
      minLength: helpers.withMessage('El nombre debe tener al menos 2 caracteres', minLength(2)),
    },
    last_name: {
      required: helpers.withMessage('El apellido es requerido', required),
      minLength: helpers.withMessage('El apellido debe tener al menos 2 caracteres', minLength(2)),
    },
    dni: {
      required: helpers.withMessage('El DNI es requerido', required),
      dniPattern,
    },
    phone_number: {
      required: helpers.withMessage('El teléfono es requerido', required),
      phonePattern,
    },
    email: {
      required: helpers.withMessage('El email es requerido', required),
      email: helpers.withMessage('Ingrese un email válido', email),
    },
  }

  if (showBusinessSection.value) {
    base.business_name = {
      required: requiredTrimmed('Ingresá el nombre del negocio'),
      minLength: helpers.withMessage('El nombre del negocio debe tener al menos 2 caracteres', minLength(2)),
    }
    base.business_address = {
      required: requiredTrimmed('Ingresá la dirección del negocio'),
      minLength: helpers.withMessage('La dirección del negocio debe tener al menos 5 caracteres', minLength(5)),
    }
    base.business_type = {
      required: requiredTrimmed('Ingresá el tipo de negocio (ej: growshop, dispensario)'),
      minLength: helpers.withMessage('El tipo de negocio debe tener al menos 2 caracteres', minLength(2)),
    }
  }

  return base
})
const v$ = useVuelidate(rules, formData)

const showVerificationForm = ref(false)
const verificationCode = ref('')
const pendingEmail = ref('')
const isRequestingCode = ref(false)
const currentPassword = ref('')

const showPasswordModal = ref(false)
const handlePasswordSubmit = ref(null)
const handlePasswordCancel = ref(null)

const showPasswordPrompt = () => {
  return new Promise((resolve) => {
    showPasswordModal.value = false
    currentPassword.value = ''
    showPasswordModal.value = true

    handlePasswordSubmit.value = (password) => {
      showPasswordModal.value = false
      currentPassword.value = ''
      resolve(password)
    }
    handlePasswordCancel.value = () => {
      showPasswordModal.value = false
      currentPassword.value = ''
      resolve(null)
    }
  })
}

const handleEmailChange = async (newEmail) => {
  try {
    isRequestingCode.value = true
    const password = await showPasswordPrompt()
    if (!password) return
    pendingEmail.value = newEmail
    await requestVerificationCode('EMAIL_CHANGE', newEmail, password)
    showVerificationForm.value = true
    toast.success('Te hemos enviado un código de verificación al nuevo email')
  } catch (error) {
    toast.error(extractApiErrorMessage(error, 'Error al solicitar verificación'))
  } finally {
    isRequestingCode.value = false
  }
}

const submitEmailChange = async () => {
  try {
    isLoading.value = true
    const response = await updateEmailWithVerification(pendingEmail.value, verificationCode.value)
    store.dispatch('setUser', response)
    formData.email = pendingEmail.value
    accountDirty.markClean()
    showVerificationForm.value = false
    verificationCode.value = ''
    pendingEmail.value = ''
    toast.success('Email actualizado correctamente')
  } catch (error) {
    console.error('Error updating email:', error)
    toast.error(extractApiErrorMessage(error, 'Error al actualizar email'))
  } finally {
    isLoading.value = false
  }
}

const handleSubmit = async () => {
  try {
    const isFormValid = await v$.value.$validate()
    if (!isFormValid) {
      const firstError = Object.values(v$.value.$errors)[0]
      if (firstError) toast.error(firstError.$message)
      return
    }

    if (formData.email !== store.state.user?.email) {
      await handleEmailChange(formData.email)
      return
    }

    isLoading.value = true
    const payload = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      dni: formData.dni,
      phone_number: formData.phone_number,
      cuit: formData.cuit,
      instagram: formData.instagram,
      facebook: formData.facebook,
      address: formData.address,
      postal_code: formData.postal_code,
      province: formData.province,
      locality: formData.locality,
    }
    if (showBusinessSection.value) {
      payload.business_name = formData.business_name
      payload.business_address = formData.business_address
      payload.business_type = formData.business_type
      payload.extra_info = formData.extra_info
    }
    const response = await updateUserProfile(payload)
    store.dispatch('setUser', response)
    toast.success('Datos actualizados correctamente')
    accountDirty.markClean()
  } catch (error) {
    console.error('Error updating profile:', error)
    toast.error(extractApiErrorMessage(error, 'Error al actualizar el perfil'))
  } finally {
    isLoading.value = false
  }
}

const showPasswordForm = ref(false)
const showCurrentPassword = ref(false)
const showNewPassword = ref(false)
const showConfirmPassword = ref(false)
const isChangingPassword = ref(false)

const passwordForm = reactive({
  currentPassword: '',
  newPassword: '',
  confirmPassword: '',
})

const accountDirty = useFormDirty(formData)
const passwordDirty = useFormDirty(passwordForm, {
  initial: { currentPassword: '', newPassword: '', confirmPassword: '' },
})
const dirty = computed(() => accountDirty.dirty.value || passwordDirty.dirty.value)

// "Guardar y salir" no puede completar flujos que requieren interacción del
// usuario (verificación de email por código, cambio de contraseña) — se avisa
// y se queda en la sección; dirty sigue true así el guard no navega.
const saveAccountAndExit = async () => {
  if (formData.email !== store.state.user?.email) {
    toast.error('El cambio de email requiere verificación por código: guardalo con el botón "Guardar cambios"')
    return
  }
  if (passwordDirty.dirty.value) {
    toast.error('La contraseña nueva tiene su propio flujo: guardala con "Cambiar contraseña"')
    return
  }
  await handleSubmit()
}

useUnsavedChangesGuard({
  dirty,
  saveFn: saveAccountAndExit,
  message: 'Tenés cambios sin guardar en tu cuenta. Si salís ahora, se van a perder.',
})

const handlePasswordChange = async () => {
  if (passwordForm.newPassword !== passwordForm.confirmPassword) {
    toast.error('Las contraseñas no coinciden')
    return
  }
  try {
    isChangingPassword.value = true
    isRequestingCode.value = false
    await changePassword(passwordForm.currentPassword, passwordForm.newPassword)
    toast.success('Contraseña actualizada correctamente')
    passwordForm.currentPassword = ''
    passwordForm.newPassword = ''
    passwordForm.confirmPassword = ''
    showPasswordForm.value = false
  } catch (error) {
    console.error('Error changing password:', error)
    toast.error(extractApiErrorMessage(error, 'Error al cambiar la contraseña'))
  } finally {
    isChangingPassword.value = false
  }
}

onMounted(async () => {
  try {
    const user = await getUserInfo()
    formData.first_name = user.first_name || ''
    formData.last_name = user.last_name || ''
    formData.dni = user.dni || ''
    formData.phone_number = user.phone_number || ''
    formData.cuit = user.cuit || ''
    formData.instagram = user.instagram || ''
    formData.facebook = user.facebook || ''
    formData.email = user.email || ''
    formData.address = user.address || ''
    formData.postal_code = user.postal_code || ''
    formData.province = user.province || ''
    formData.locality = user.locality || ''
    formData.business_name = user.business_name || ''
    formData.business_address = user.business_address || ''
    formData.business_type = user.business_type || ''
    formData.extra_info = user.extra_info || ''
    userRequiresBusinessInfo.value = !!user.requires_business_info
    accountDirty.markClean()
  } catch (error) {
    console.error('Error loading user info:', error)
    if (error.response?.status === 401) {
      router.push('/login')
    } else {
      toast.error('Error al cargar la información')
    }
  }
})
</script>

<style scoped>
.account-page { max-width: 760px; }

.form-group { margin-bottom: 0.25rem; }
.form-group label {
  color: var(--white-color);
  margin-bottom: 0.4rem;
  display: block;
  font-size: 0.85rem;
  font-weight: 500;
}
.form-control {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid var(--panel-border);
  color: var(--white-color);
  border-radius: 10px;
  padding: 0.7rem 0.95rem;
}
.form-control:focus {
  background: rgba(0, 0, 0, 0.3);
  border-color: var(--primary-color);
  color: var(--white-color);
  box-shadow: 0 0 0 3px rgba(255, 236, 0, 0.12);
}
.form-actions {
  margin-top: 1.75rem;
  display: flex;
  justify-content: flex-end;
}
.business-section {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--panel-border);
}
.business-section-title {
  color: var(--primary-color);
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 1.25rem;
}
.invalid-feedback {
  font-size: 0.78rem;
}
.input-group .btn-outline-secondary {
  border-color: var(--panel-border);
  color: var(--panel-text-muted);
  background: rgba(0, 0, 0, 0.25);
}
.input-group .btn-outline-secondary:hover {
  background: rgba(0, 0, 0, 0.35);
  color: var(--white-color);
}
.input-group .form-control { border-right: none; }
.input-group .btn { border-left: none; }

.btn-outline-light {
  border-color: rgba(255, 255, 255, 0.2);
  color: var(--white-color);
}
.btn-outline-light:hover {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: var(--black-color);
}

.verification-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}
.verification-modal {
  background: var(--grey-color);
  border: 1px solid var(--black-color-2);
  padding: 2rem;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
}
.verification-modal h3 { color: var(--white-color); margin-bottom: 0.75rem; }
.verification-modal p { color: rgba(255, 255, 255, 0.65); }
.modal-actions { display: flex; gap: 1rem; margin-top: 1.5rem; }
.modal-actions button { flex: 1; }
</style>
